export default __webpack_public_path__ + "static/media/teplo.e2746417.pdf";